import { URL } from '../../constants';
import { httpApiService } from '../../utils/create-http-api-service';
import { defaultRequestService } from '../../utils/default-request-service';

// ---

type CitiesFromBackend = string[];

export const getCities = (inputValue: string) => {
  type AdapterProps = { response: CitiesFromBackend };
  const url = `${URL.GEO}?name=${inputValue}`;

  return defaultRequestService<AdapterProps>(url, httpApiService.get);
};
